import { createTheme, responsiveFontSizes } from "@mui/material/styles";

// @todo: breakpoints are different compared to MUI
export const muiDefaultTheme = responsiveFontSizes(
  createTheme({
    breakpoints: {
      values: {
        xs: 0,
        sm: 600,
        md: 960,
        lg: 1280,
        xl: 1920,
      },
    },
    palette: {
      primary: { main: "#F05623", light: "#F05623", dark: "#F05623" },
      secondary: { main: "#ACACAC", light: "#ACACAC", dark: "#ACACAC" },
      textColor2: { main: "#0064FF", light: "#0064FF", dark: "#0064FF" },
    },
    components: {
      MuiButton: {
        defaultProps: {
          disableElevation: true,
          color: "inherit",
        },
        styleOverrides: {
          root: {
            fontWeight: 700,
            // color: "#666666",
            fontSize: "0.875rem",
            padding: "0.5rem 1rem",
            lineHeight: "1.75",
          },
          contained: {},
          outlinedPrimary: {
            borderWidth: "2px",
            borderColor: "#F05623",
            "&:hover": {
              borderWidth: "2px",
              backgroundColor: "#F05623",
              color: "#fff",
              borderColor: "#F05623",
            },
          },
          outlinedSecondary: {
            borderWidth: "2px",
            borderColor: "#ACACAC",
            "&:hover": {
              borderWidth: "2px",
              backgroundColor: "#ACACAC",
              color: "#fff",
              borderColor: "#ACACAC",
            },
          },
          outlined: {
            padding: "0.375rem 1rem",
          },
          // outlinedPrimary: {
          //   borderWidth: "1px",
          // },
          // outlinedSecondary: {
          //   borderWidth: "1px",
          // },
        },
      },
      MuiSelect: {
        defaultProps: {
          variant: "standard",
        },
      },
      MuiCheckbox: {
        defaultProps: {
          color: "secondary",
        },
      },
      MuiLink: {
        defaultProps: {
          underline: "hover",
        },
      },
      MuiFormControl: {
        styleOverrides: {
          variant: "standard",
        },
      },
      MuiTextField: {
        defaultProps: {
          variant: "standard",
        },
      },
      MuiPaper: {
        styleOverrides: { root: { backgroundImage: "unset" } },
      },
      MuiRadio: {
        defaultProps: {
          color: "secondary",
        },
      },
    },
  })
);
